<!-- Modals -->
<ui-dialog
    [open]="currentlyOpenDialog === 'RENAME_EDIT_TAGS'"
    (primaryButtonPressed)="onSave(editForm)"
    (secondaryButtonPressed)="onCancel()"
    (closing)="onCancel()"
    primaryButtonLabel="save"
    secondaryButtonLabel="cancel"
    [form]="editForm.form"
    header="document.editDocument"
    size="small"
>
    <app-company-document-form
        #editForm
        [companyDocument]="companyDocument"
        [allTags]="allTags"
        [showNumberOfCosigner]="false"
    ></app-company-document-form>
</ui-dialog>

<ui-confirmation-dialog
    #bulkRemindConfirm
    header="document.remindEmployees"
    primaryButtonLabel="document.remind"
    secondaryButtonLabel="cancel"
    >{{ 'document.remindEmployeesNotice' | translate }}</ui-confirmation-dialog
>

<ui-dialog
    [open]="currentlyOpenDialog === 'MULTI_SIGNER'"
    [form]="multiSignerAssignmentNgForm"
    header="document.assignRoles"
    [stickyButtons]="true"
    [stickyHeader]="true"
    (closing)="onCancelMultiSigner()"
    [size]="'small'"
>
    <div>
        <ui-banner
            *ngIf="hasCustomFieldAssignments"
            variant="warning"
            class="margin-y-1 align-banner-text padding-bottom-2"
        >
            <p>{{ 'document.customFieldsAssignmentWarning' | translate }}</p>
        </ui-banner>

        <form #multiSignerAssignmentNgForm="ngForm">
            <app-form-multi-signer-assignment
                #multiSignerAssignmentForm
                [isRequired]="true"
                [template]="companyDocument?.signingTemplate"
                [assigningOrder]="assigningOrder"
                (onSlotChange)="updateSlots($event)"
                [allowNone]="true"
            ></app-form-multi-signer-assignment>
        </form>
    </div>

    <ui-dialog-footer class="sticky-buttons">
        <div class="assign-roles-footer">
            <mat-checkbox
                name="assigningOrder"
                [ngModel]="assigningOrder"
                (ngModelChange)="assigningOrder = !assigningOrder"
                >{{ 'forms.multi-signer-assignment.assignSigningOrder' | appTranslate }}
            </mat-checkbox>
            <div class="flex">
                <ui-button (click)="onCancelMultiSigner()" type="ghost">{{ 'cancel' | appTranslate }}</ui-button>
                <ui-button (click)="onSaveMultiSignerAssignment(multiSignerAssignmentNgForm)" type="primary">{{
                    'save' | appTranslate
                }}</ui-button>
            </div>
        </div>
    </ui-dialog-footer>
</ui-dialog>

<!-- This is to set default cosigners. It is currently only for offer letters. -->
<ui-dialog
    [open]="currentlyOpenDialog === 'DEFAULT_COSIGNERS'"
    [form]="form"
    [size]="'small'"
    header="document.setupDefaultCosigners"
    [stickyButtons]="true"
    [stickyHeader]="true"
    (closing)="onCancelDefaultCosigners(defaultCosignersForm)"
>
    <p class="margin-bottom-3">{{ 'offer-letter.defaultCosignerModalHelpText' | translate }}</p>

    <form #form="ngForm">
        <div class="app-grid">
            <div class="columns-7">
                <app-form-multi-signer-assignment
                    #defaultCosignersForm
                    [isRequired]="false"
                    [template]="defaultSigningTemplate"
                    [assigningOrder]="assigningOrderDefaultSigner"
                    (onSlotChange)="updateSlots($event)"
                    [isSettingDefaultAssignment]="true"
                    [allowNone]="true"
                ></app-form-multi-signer-assignment>
            </div>
        </div>
    </form>

    <!-- Checkbox for ordering -->
    <ui-dialog-footer class="sticky-buttons">
        <div class="assign-roles-footer">
            <mat-checkbox
                *ngIf="defaultSigningTemplate?.slots?.length > 2"
                name="assigningOrder"
                [ngModel]="assigningOrderDefaultSigner"
                (ngModelChange)="assigningOrderDefaultSigner = !assigningOrderDefaultSigner"
                >{{ 'forms.multi-signer-assignment.assignSigningOrder' | appTranslate }}
            </mat-checkbox>
            <div class="flex">
                <ui-button (click)="onCancelDefaultCosigners(defaultCosignersForm)" type="ghost">{{
                    'cancel' | appTranslate
                }}</ui-button>
                <ui-button (click)="onSaveDefaultCosigners(form)" type="primary">{{ 'save' | appTranslate }}</ui-button>
            </div>
        </div>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="currentlyOpenDialog === 'DETAILS'"
    (closing)="closeDialog()"
    header="document.documentDetails"
    ><app-document-details [document]="companyDocument"></app-document-details>
</ui-dialog>

<app-common-bulk-select-employee-dialog #appEmployeeSelection [label]="'Assign'">
    <ui-banner
        *ngIf="hasCustomFieldAssignments"
        variant="warning"
        class="margin-y-1 align-banner-text padding-bottom-2"
    >
        <p>{{ 'document.customFieldsAssignmentWarning' | translate }}</p>
    </ui-banner>
</app-common-bulk-select-employee-dialog>

<app-company-document-deletion-modal #companyDocumentDeletionModal></app-company-document-deletion-modal>

<ui-confirmation-dialog
    #lackingSigningTemplateModal
    header="document.signingTemplateRequired"
    primaryButtonLabel="document.goToEditor"
    secondaryButtonLabel="cancel"
>
    {{ 'document.addAnnotations' | translate }}
</ui-confirmation-dialog>

<!-- Template -->
<ng-container *ngIf="companyDocument">
    <app-header
        [title]="companyDocument?.name"
        [back]="true"
        backRoute="{{ companyDocumentBackRoute }}"
        [menuService]="menuService"
        [contextMenu]="showMeatballMenu"
    >
        <div class="buttons">
            <ng-container *ngIf="companyDocument?.isSigningDocument() && showTemplateEditButton">
                <ui-button
                    *permission="editDocumentPermission"
                    [url]="'signingTemplate/' + companyDocument.signingTemplate.id"
                    type="outline"
                    [disabled]="!isTemplateReady()"
                    >{{ 'document.templateEditor' | translate }}</ui-button
                >
            </ng-container>

            <ng-container *ngIf="companyDocument.isOfferLetter() && hasCosigners">
                <ui-button
                    type="outline"
                    *permission="hirePermissions"
                    (click)="openDefaultCosigners(form, defaultCosignersForm)"
                    >{{ 'document.defaultCosigners' | translate }}</ui-button
                >
            </ng-container>

            <ng-container *ngIf="!companyDocument.isOfferLetter() && !companyDocument.isViewOnly()">
                <ui-button
                    [disabled]="!isTemplateReady()"
                    *permission="editDocumentPermission"
                    type="primary"
                    (click)="multiAssignDocument(multiSignerAssignmentNgForm, multiSignerAssignmentForm)"
                    >{{ 'document.assign' | translate }}</ui-button
                >
            </ng-container>

            <ng-container *ngIf="!companyDocument.isOfferLetter() && !companyDocument.isViewOnly()">
                <ui-button
                    type="outline"
                    *ngIf="companyDocument.hasIncompleteAssignments() && showRemindButton"
                    (click)="bulkRemind()"
                    >{{ 'document.remindAll' | translate }}</ui-button
                >
            </ng-container>

            <ng-container *ngIf="companyDocument.isOfferLetter()">
                <ui-button
                    [disabled]="!isTemplateReady()"
                    *permission="hirePermissions"
                    type="primary"
                    [url]="'/employees/offer-letters/new'"
                    [queryParams]="{
                        signingTemplateId: companyDocument.signingTemplate.id,
                        referer: offerLetterReferer,
                    }"
                    >{{ 'document.sendToCandidate' | translate }}</ui-button
                >
            </ng-container>
        </div>

        <ng-container *ngIf="showMeatballMenu">
            <app-context-item (click)="onDownload()" label="document.download"></app-context-item>

            <app-context-item
                *permission="editDocumentPermission"
                (click)="currentlyOpenDialog = 'RENAME_EDIT_TAGS'"
                label="document.renameEditTags"
            ></app-context-item>
            <app-context-item (click)="onDetails()" label="document.documentDetails"></app-context-item>
            <app-context-item
                *permission="editDocumentPermission"
                (click)="onDeleteCompanyDocument()"
                label="document.delete"
            ></app-context-item>
        </ng-container>
    </app-header>
</ng-container>
